import { createStitches as e } from "@stitches/react";
const { keyframes: r, styled: o } = e();
export {
  r as keyframes,
  o as styled
};
//# sourceMappingURL=stitches.config.es.mjs.map
